import { Component, NgZone, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginAuthProperties } from 'server/shared/helpers/types/AuthProperties';
import { PasswordResetType } from 'server/shared/models/user';
import { AccountService } from '../../services/account.service';
import { ToastService } from '../../services/toast/toast.service';
@Component({
  selector: 'auth-reset',
  templateUrl: 'reset-password-form.component.html',
  styleUrls: ['reset-password-form.component.scss'],
})
export class ResetPasswordFormComponent implements OnDestroy {
  token?: string;
  type?: string;
  routeParamSubscription: Subscription;

  showLoadingIndicator: boolean = false;
  authData?: LoginAuthProperties;
  form = new FormGroup(
    {
      password1: new FormControl(null, [
        Validators.required,
        Validators.minLength(8),
      ]),
      password2: new FormControl(null, [Validators.required]),
    },
    { updateOn: 'submit' },
  );

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
    private ngZone: NgZone,
    public accountService: AccountService,
  ) {
    this.routeParamSubscription = this.route.params.subscribe((params) => {
      this.token = params['token'];
    });
    let splitedUrl = this.router.url.split('/');
    this.type = splitedUrl[1];
  }

  resetPassword() {
    if (!this.form || !this.token || !this.type) return;
    if (
      this.form.controls.password1.value !== this.form.controls.password2.value
    ) {
      this.form.controls.password2.setErrors({ isNotSame: true });
      return;
    }
    if (this.form.invalid) return;

    this.ngZone.run(() => {
      this.showLoadingIndicator = true;
    });
    let arg: PasswordResetType = {
      token: this.token,
      password: this.form.controls.password1.value,
      type: this.type,
    };
    Meteor.call(
      'resetPasswordAndConfirm',
      arg,
      (error: Meteor.Error, result: any) => {
        if (error) {
          if (error.error == 'tokenInvalid') {
            this.toastService.add({
              type: 'ERROR',
              message: 'wrongOrExpiredToken',
            });
          } else {
            console.error(error);
            this.toastService.add({ type: 'ERROR', message: 'serverError' });
          }
        } else {
          if (result && this.form) {
            this.authData = {
              user: { email: result.email },
              password: this.form.controls.password1.value,
            };
            if (result.twoFactorAuthCodeSent) {
              this.accountService.twoFactorAuthRequired.next(true);
            } else {
              this.accountService.loginMethod(
                { ...this.authData },
                false,
                true,
              );
            }
          }
        }
        this.ngZone.run(() => {
          this.showLoadingIndicator = false;
        });
      },
    );
  }

  ngOnDestroy() {
    if (this.routeParamSubscription) {
      this.routeParamSubscription.unsubscribe();
    }
  }
}
